module.exports = __webpack_public_path__ + "static/media/WSB_logo_white.152fbb9d.png";